import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import dateFormat from "dateformat";
import ListPagination from "../../components/ListPagination/ListPagination";

const useStyles = makeStyles({
	table: {
		"& tbody": {
			textTransform: "uppercase",

			"& th,td": {
				fontWeight: "bold",
			},
		},
	},
	filterRow: {
		display: "flex",
		gap: "12px",
		alignItems: "center",
		marginBottom: "16px",
		flexWrap: "wrap",
	},
});

const RoundHistoryTable = ({
	roundList,
	total,
	page,
	limit,
	selectedRoom,
	roomCodes,
	onRoomChange,
	onRefresh,
	onPageChange,
	onLimitChange,
}) => {
	const classes = useStyles();
	const history = useHistory();
	const isLast = (index) => index === roundList.length - 1;

	const getPlayerCount = (round) =>
		round.playerCount ??
		(Array.isArray(round.room?.players)
			? round.room.players.length
			: round.room?.players?.length ?? 0);

	return (
		<>
			<div className={classes.filterRow}>
				<Select
					value={selectedRoom}
					onChange={(event) => onRoomChange(event.target.value)}
					displayEmpty
					style={{ minWidth: 180 }}
				>
					<MenuItem value="">All Rooms</MenuItem>
					{roomCodes.map((roomCode) => (
						<MenuItem key={roomCode} value={roomCode}>
							{roomCode}
						</MenuItem>
					))}
				</Select>

				<Button variant="outlined" color="primary" onClick={onRefresh}>
					Refresh
				</Button>
			</div>

			<TableContainer>
				<Table
					className={classes.table}
					style={{ tableLayout: "fixed" }}
					aria-label="round history table"
				>
					<TableHead>
						<TableRow>
							<TableCell>Date</TableCell>
							<TableCell>No. of Questions</TableCell>
							<TableCell>Room</TableCell>
							<TableCell>No. of Players</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{roundList.length === 0 ? (
							<TableRow>
								<TableCell colSpan={4} align="center">
									No rounds match the current filters.
								</TableCell>
							</TableRow>
						) : (
							roundList.map((game, gameIndex) => (
							<TableRow key={game._id || gameIndex}>
								<TableCell
									component="th"
									scope="row"
									style={{
										borderBottom: isLast(gameIndex) ? 0 : undefined,
									}}
								>
									<Button
										color="primary"
										onClick={() =>
											history.push(`/round-history/${game._id}`)
										}
									>
										{dateFormat(game.createdAt, "dddd mmm d, yyyy")}
									</Button>
								</TableCell>
								<TableCell
									component="th"
									scope="row"
									style={{
										borderBottom: isLast(gameIndex) ? 0 : undefined,
									}}
								>
									{Array.isArray(game.questions)
										? game.questions.length
										: 0}
								</TableCell>
								<TableCell
									style={{
										borderBottom: isLast(gameIndex) ? 0 : undefined,
									}}
								>
									{game.room?.roomCode || game.roomCode || "—"}
								</TableCell>
								<TableCell
									style={{
										borderBottom: isLast(gameIndex) ? 0 : undefined,
									}}
								>
									{getPlayerCount(game)}
								</TableCell>
							</TableRow>
						))
						)}
					</TableBody>
				</Table>
			</TableContainer>

			<ListPagination
				total={total}
				page={page}
				limit={limit}
				onPageChange={onPageChange}
				onLimitChange={onLimitChange}
			/>
		</>
	);
};

export default RoundHistoryTable;
